import { render, staticRenderFns } from "./CloseScreeningModal.vue?vue&type=template&id=825fa74a&scoped=true"
import script from "./CloseScreeningModal.vue?vue&type=script&lang=js"
export * from "./CloseScreeningModal.vue?vue&type=script&lang=js"
import style0 from "./CloseScreeningModal.vue?vue&type=style&index=0&id=825fa74a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825fa74a",
  null
  
)

export default component.exports